import React from 'react';
import Alert from '@amzn/awsui-components-core/alert';
import Box from '@amzn/awsui-components-core/box';
import Container from '@amzn/awsui-components-core/container';
import Header from '@amzn/awsui-components-core/header';
import SegmentedControl from '@amzn/awsui-components-core/segmented-control';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import Spinner from '@amzn/awsui-components-core/spinner';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import type { DatasetWizardState } from 'src/components/star-grid/datasets/hooks/useDatasetWizard';
import { QuerySqlBlock, type SqlForm } from 'src/components/star-grid/components/QuerySqlBlock';

/** The query the dataset generates (values bound, or as written), shown without running it. */
export const ReviewGeneratedQuery: React.FC<{ state: DatasetWizardState; text: StarGridText }> = ({ state, text }) => {
  const [form, setForm] = React.useState<SqlForm>('run');
  const preview = state.reviewPreview;
  const query = preview?.query;
  const body = state.reviewPreviewLoading ? (
    <Box>
      <Spinner /> {text('wizardReviewQueryLoading')}
    </Box>
  ) : state.reviewPreviewError ? (
    <Alert type="warning" data-testid="review-preview-error">
      {state.reviewPreviewError}
    </Alert>
  ) : !preview ? (
    <Box color="text-body-secondary">{text('wizardReviewQueryUnavailable')}</Box>
  ) : (
    <SpaceBetween size="s">
      {query && (
        <SpaceBetween size="xs">
          <SegmentedControl
            selectedId={form}
            onChange={({ detail }) => setForm(detail.selectedId as SqlForm)}
            options={[
              { id: 'run', text: text('statsSqlAsRun') },
              { id: 'code', text: text('statsSqlAsCode') }
            ]}
          />
          <QuerySqlBlock sql={query.sql} template={query.template} form={form} />
        </SpaceBetween>
      )}
    </SpaceBetween>
  );
  return (
    <Container header={<Header variant="h3">{text('wizardReviewQuery')}</Header>} data-testid="review-generated-query">
      {body}
    </Container>
  );
};
